"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _ComponentData2 = _interopRequireDefault(require("./ComponentData"));

var _ScoreUtil = _interopRequireDefault(require("../../util/ScoreUtil"));

var OverallData =
/*#__PURE__*/
function (_ComponentData) {
  (0, _inherits2.default)(OverallData, _ComponentData);

  function OverallData() {
    (0, _classCallCheck2.default)(this, OverallData);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(OverallData).apply(this, arguments));
  }

  (0, _createClass2.default)(OverallData, [{
    key: "setGradeType",
    value: function setGradeType(grade) {
      this.gradeType = _ScoreUtil.default.getOverallGradeType(grade);
    }
  }]);
  return OverallData;
}(_ComponentData2.default);

var _default = OverallData;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/data/components/OverallData.js
// module id = 158
// module chunks = 0